export default "__VITE_ASSET__CeaBzIpd__"